export default {
    getAllBoxes: env => {
        return {
            url: `/${env}/boxes`,
            method: 'GET'
        };
    },
    getBoxDetails: (env, macAddress) => {
        return {
            url: `/${env}/boxes/:macAddress`,
            method: 'GET',
            route_params: {
                macAddress
            }
        };
    },

    updateBoxDetails: (env, boxMac, boxForm) => {
        return {
            url: `/${env}/boxes/:boxMac`,
            method: 'PATCH',
            route_params: {
                boxMac
            },
            patch_params: {
                brand: boxForm.brand
            }
        };
    },
    autocompleteBoxMac: (env, macAddr) => {
        return {
            url: `/${env}/boxes/autocomplete`,
            method: 'GET',
            get_params: {
                macAddr
            }
        };
    },
    dissociateBox: (env, boxeMac, homeId) => {
        return {
            url: `/${env}/boxes/:boxeMac/dissociate`,
            method: 'POST',
            route_params: {
                boxeMac
            },
            post_params: {
                homeId
            }
        };
    },
    associateBox: (env, boxeMac, homeId) => {
        return {
            url: `/${env}/boxes/:boxeMac/associate`,
            method: 'PATCH',
            route_params: {
                boxeMac
            },
            post_params: {
                homeId
            }
        };
    },
    logClientInterfaceConnection: (env, homeId) => {
        return {
            url: `/${env}/clientInterfaceConnection/:homeId`,
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    getClientToken: (env, homeId) => {
        return {
            url: `/${env}/getClientToken/:homeId`,
            method: 'GET',
            route_params: {
                homeId
            }
        };
    },
    boxSwap: (env, swapData) => {
        return {
            url: `/${env}/boxes/swap`,
            method: 'PATCH',
            post_params: swapData
        };
    },
    homeDelete: (env, homeId, boxId) => {
        return {
            url: `/${env}/homes/:homeId/boxes/:boxId/delete-home`,
            method: 'POST',
            route_params: {
                homeId,
                boxId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Boxes/api.js